// React import
import { useEffect, useRef } from "react";

// Context and hooks imports
import useComponents from "../../../Hooks/Display/useComponents";

// Component imports
import { Popup } from "@progress/kendo-react-popup";
import { Menu, MenuItem } from "@progress/kendo-react-layout";

// Events import
import { TOGGLE_CONTEXT_MENU, TOGGLE_DELETE_COMPONENT_DIALOG } from "../../../Context/Display/Components/ComponentsContextEvents";

function ContextMenu() {

    const [{ showContextMenu, contextMenuOffset, contextMenuItemIndex }, dispatchPageEvent] = useComponents();

    const popup = useRef(null);
    useEffect(() => {
        document.addEventListener("click", checkOutsideClick);

        return () => {
            document.removeEventListener("click", checkOutsideClick);
        }
    }, [showContextMenu])

    function checkOutsideClick(e) {
        if (popup.current !== null && !popup.current.contains(e.target)) {
            if (showContextMenu) {
                toggleContextMenu()
            }
        }
    };

    function showDeleteOption() {
        return true
    }

    function showCopyOption() {
        return true;
    }

    function showResetOption() {
        return true;
    }

    function handleEdit() {
        dispatchPageEvent({
            type: "TOGGLE_EDIT_PAGE_DIALOG",
            payload: contextMenuItemIndex
        })
    }

    function handleDelete() {
        dispatchPageEvent({
            type: TOGGLE_DELETE_COMPONENT_DIALOG,
            payload: contextMenuItemIndex
        })
    }

    function handleCopy() {
        console.log("Copy");
    }

    function handlePaste() {
        console.log("Paste");
    }

    function handleMenuItemSelect(event) {
        switch(event.itemId) {
            case '0':
                showDeleteOption() ? handleDelete() : handleEdit();
                break;
            case '1':
                handleCopy();
                break;
            case '2':
                handlePaste();
                break;
            default:
                break;
        }
        toggleContextMenu();
    }

    function toggleContextMenu() {
        dispatchPageEvent({
            type: TOGGLE_CONTEXT_MENU,
            payload: {}
        })
    }

    return (
        <Popup
            animate={false}
            style={{ width: "150px" }}
            show={showContextMenu}
            offset={contextMenuOffset}
        >
            <div className="w-100" ref={menu => popup.current = menu}>
                <Menu
                    vertical
                    style={{ display: "inline-block", width: "100%" }}
                    onSelect={handleMenuItemSelect}
                >
                    {
                        showDeleteOption() &&
                        <MenuItem text="Delete" />
                    }
                    {
                        showResetOption() &&
                        <MenuItem text="Reset" />
                    }
                    {
                        showCopyOption() ?
                        <MenuItem text="Copy" /> : null
                    }
                    {
                        showCopyOption() &&
                        localStorage.getItem("copiedPageInformation") !== null &&
                        localStorage.getItem("copiedPageInformation") !== "" ?
                        <MenuItem text="Paste" /> : null
                    }
                </Menu>
            </div>
        </Popup>
    )
}

export default ContextMenu;